import type React from 'react';
import { useEffect, useState } from 'react';
import { useInView } from 'react-intersection-observer';
import VodVideo from 'components/VodVideo';
import type { Article } from 'interfaces/content/articles/Articles';
import StnVideo from 'components/StnVideo';
import Placeholder from 'components/Placeholder';
import type { BrandedArticle } from 'interfaces/content/articles/Post';
import Wrapper from './RelatedVideoStyles';

interface RelatedVideoProps {
  article: Article | BrandedArticle;
  supressStnFloating?: boolean;
}

const RelatedVideo: React.FC<RelatedVideoProps> = ({ article, supressStnFloating }) => {
  const [displayVideo, setDisplayVideo] = useState(false);
  const [vodRef, inViewPort] = useInView({ threshold: 0 });
  const { adTags } = article;

  useEffect(() => {
    if (inViewPort) {
      setDisplayVideo(true);
    }
  }, [inViewPort]);

  const isStnVideo = article.relatedVideoType === 'stn_video_media';

  return (
    <div
      className={'related-video-container'}
      id={'related-video'}
      ref={vodRef}
    >
      {displayVideo ? (
        <>
          <h2>Recommended Video</h2>
          <hr />
          {isStnVideo ? (
            <StnVideo
              videoId={article.relatedVideoId}
              adTags={adTags}
              supressStnFloating={supressStnFloating}
            />
          ) : (
            <VodVideo
              videoId={article.relatedVideoId}
              disableAutoplay={false}
            />
          )}
        </>
      ) : (
        <Wrapper>
          <Placeholder size={{ height: 64, width: 180 }} />
          <Placeholder
            className='video-placeholder'
            size={{ height: '100%', maxWidth: 745, minHeight: 220, width: '100%' }}
          />
        </Wrapper>
      )}
    </div>
  );
};

export default RelatedVideo;
